<template>
  <div>
    <hero-cards-color-set
      :cards="heroCards1"
      cardColor="blue"
    ></hero-cards-color-set>

    <section class="itb-cleaning">
      <div class="container">
        <div
          class="itb-cleaning-bubble-middle"
          v-lazy:background-image="
            '/images/articles/cleaning/cleaning-bubble-middle.webp'
          "
        ></div>
        <div class="row" v-for="(bAImage, bAImageIndex) in beforeAfterImages1">
          <div class="col-12 col-md-6 itb-cleaning-row-gap">
            <div
              class="itb-comparison-image"
              v-lazy:background-image="bAImage.before"
            >
              <div
                class="itb-thumb-image down"
                v-lazy:background-image="
                  '/images/articles/cleaning/thumbs-down.webp'
                "
              ></div>
            </div>
          </div>
          <div class="col-12 col-md-6 itb-cleaning-row-gap">
            <div
              class="itb-comparison-image"
              v-lazy:background-image="bAImage.after"
            >
              <div
                class="itb-thumb-image"
                v-lazy:background-image="
                  '/images/articles/cleaning/thumbs-up.webp'
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="row">
          <div
            class="col-12 d-flex flex-column align-items-center itb-youtube-video"
          >
            <h2 class="text-center">
              {{ $t("cleaning.cleaning_youtube_video_title") }}
            </h2>
            <div
              class="d-flex justify-content-center align-items-center itb-youtube-warning-wrap"
            >
              <p
                class="mb-0 itb-youtube-warning"
                style="font-size: 1.71rem; max-width: 1180px"
                :class="{
                  'itb-youtube-warning-highlight': isYoutubeHighlighted,
                }"
              >
                {{ $t("general.youtube_warning") }}
                <a href="https://policies.google.com/privacy" target="_blank"
                  >{{ $t("general.youtube_policy") }}.</a
                >
              </p>
              <button
                class="btn btn-secondary ml-2"
                :disabled="youtubePermit"
                @click="youtubePermit = true"
              >
                {{ $t("cookies.accept") }}
              </button>
            </div>
            <div
              v-if="!youtubePermit"
              class="itb-youtube-image d-flex justify-content-center align-items-center"
              style="max-width: 1000px"
              @click="warningHighlight"
            >
              <img src="/images/youtube-logo.png" alt="youtube-logo" />
            </div>
            <iframe
              :src="pageParams.page_first_video_link"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              v-else
            ></iframe>
          </div>
        </div>
      </div>
    </section>

    <hero-cards-color-set
      style="margin-top: 4rem"
      :cards="heroCards2"
      cardColor="orange"
    ></hero-cards-color-set>

    <section class="itb-cleaning mb-0">
      <div class="container">
        <div
          class="itb-cleaning-bubble-middle"
          v-lazy:background-image="
            '/images/articles/cleaning/cleaning-bubble-middle-2.webp'
          "
        ></div>
        <div
          class="row"
          v-for="(bAImage2, bAImageIndex2) in beforeAfterImages2"
        >
          <div class="col-12 col-md-6 itb-cleaning-row-gap">
            <div
              class="itb-comparison-image"
              v-lazy:background-image="bAImage2.before"
            >
              <div
                class="itb-thumb-image down"
                v-lazy:background-image="
                  '/images/articles/cleaning/thumbs-down-2.webp'
                "
              ></div>
            </div>
          </div>
          <div class="col-12 col-md-6 itb-cleaning-row-gap">
            <div
              class="itb-comparison-image"
              v-lazy:background-image="bAImage2.after"
            >
              <div
                class="itb-thumb-image"
                v-lazy:background-image="
                  '/images/articles/cleaning/thumbs-up-2.webp'
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="itb-cleaning">
      <div class="container">
        <div
          class="itb-cleaning-bubble-middle itb-cleaning-bubble-middle-adjustment"
          v-lazy:background-image="
            '/images/articles/cleaning/cleaning-bubble-middle-3.webp'
          "
        ></div>
        <div
          class="row"
          v-for="(bAImage3, bAImageIndex3) in beforeAfterImages3"
        >
          <div class="col-12 col-md-6 itb-cleaning-row-gap">
            <div
              class="itb-comparison-image"
              v-lazy:background-image="bAImage3.before"
            >
              <div
                class="itb-thumb-image down"
                v-lazy:background-image="
                  '/images/articles/cleaning/thumbs-down-2.webp'
                "
              ></div>
            </div>
          </div>
          <div class="col-12 col-md-6 itb-cleaning-row-gap">
            <div
              class="itb-comparison-image"
              v-lazy:background-image="bAImage3.after"
            >
              <div
                class="itb-thumb-image"
                v-lazy:background-image="
                  '/images/articles/cleaning/thumbs-up-2.webp'
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <hero-cards-color-set
      style="margin-top: 4rem"
      :cards="heroCards3"
      cardColor="orange"
    ></hero-cards-color-set>

    <section class="itb-cleaning-bottom-section mb-5">
      <div class="container">
        <div class="itb-cleaning-bottom-section-content">
          <h2>{{ $t("cleaning.bottom_section.title") }}</h2>
          <ul>
            <li>{{ $t("cleaning.bottom_section.text_1") }}</li>
            <li>{{ $t("cleaning.bottom_section.text_2") }}</li>
            <li>{{ $t("cleaning.bottom_section.text_3") }}</li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      heroCards1: [],
      heroCards2: [],
      heroCards3: [],
      pageParams: [],
      youtubePermit: false,
      isYoutubeHighlighted: false,
      beforeAfterImages1: [
        {
          before: "/images/articles/cleaning/before-after-1-1.webp",
          after: "/images/articles/cleaning/before-after-1-2.webp",
        },
        {
          before: "/images/articles/cleaning/before-after-2-1.webp",
          after: "/images/articles/cleaning/before-after-2-2.webp",
        },
        {
          before: "/images/articles/cleaning/before-after-3-1.webp",
          after: "/images/articles/cleaning/before-after-3-2.webp",
        },
      ],
      beforeAfterImages2: [
        {
          before: "/images/articles/cleaning/before-after-2-1-1.webp",
          after: "/images/articles/cleaning/before-after-2-1-2.webp",
        },
      ],
      beforeAfterImages3: [
        {
          before: "/images/articles/cleaning/before-after-3-1-1.webp",
          after: "/images/articles/cleaning/before-after-3-1-2.webp",
        },
      ],
    };
  },

  mounted() {
    axios
      .get(`/getCleaningPage`)
      .then((response) => {
        this.heroCards1 = response.data.heroCards1;
        this.heroCards2 = response.data.heroCards2;
        this.heroCards3 = response.data.heroCards3;
        this.pageParams = response.data.params;
        this.pageParams.contactFormTitle = this.$t(
          "cleaning.contact_form_title"
        );

        this.setPageParams(this.pageParams);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  computed: {
    ...mapGetters({
      appParams: "getAppParams",
    }),
  },

  methods: {
    ...mapActions(["setPageParams"]),

    scrollToElement(elementId) {
      this.$parent.scrollToElement(elementId);
    },

    warningHighlight() {
      this.isYoutubeHighlighted = true;
      setTimeout(() => {
        this.isYoutubeHighlighted = false;
      }, 1500);
    },
  },
};
</script>
